<footer class="homepage-footer">
  <div class="footer-inner">
    <div class="footer-left">
      <img [src]="clientLogoSrc" alt="Client Logo" class="client-logo" />
      <span class="client-text">{{ clientText }}</span>
    </div>
    <div class="footer-right">
      <img [src]="riminiLogoSrc" alt="Rimini AgenticUX" class="rimini-logo" />
    </div>
  </div>
</footer>
